export default {"src":"/_next/static/media/solar_power.5bfa3728.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};